module.exports = __webpack_public_path__ + "static/media/outstanding-payment.7c1c48c3.svg";